import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import baseQueryWithAuth from "./baseQuery";

interface Reward {
  id: string
  dateReceived: string
  dateRedeemed?: string
}

export const rewardsApi = createApi({
  reducerPath: 'rewardsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Rewards'],
  endpoints: (builder) => ({
    getMyRewards: builder.query<Reward[], string>({
      query: (storeId: string) => ({
        url: `https://get-my-rewards.gyore-soma.workers.dev/${storeId}`,
      }),
      providesTags: ['Rewards'],
    }),
    deleteReward: builder.mutation({
      query: (rewardId) => ({
        url: `https://redeem-reward.gyore-soma.workers.dev/${rewardId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Rewards'],
    }),
  }),
})

export const { useGetMyRewardsQuery, useDeleteRewardMutation } = rewardsApi
